export interface PendingAttachment {
  localId: string;
  previewUrl: string;
  fileName: string;
  uploadId?: string;
  status: "uploading" | "ready" | "error";
  error?: string;
}

interface AttachmentPreviewProps {
  items: PendingAttachment[];
  onRemove: (localId: string) => void;
}

export function AttachmentPreview({ items, onRemove }: AttachmentPreviewProps) {
  if (items.length === 0) return null;

  return (
    <div className="mb-3 flex flex-wrap gap-3">
      {items.map((item) => (
        <div
          key={item.localId}
          className="relative h-20 w-20 overflow-hidden rounded-lg border border-gray-200 bg-gray-50"
        >
          <img
            src={item.previewUrl}
            alt={item.fileName}
            className="h-full w-full object-cover"
          />

          {item.status === "uploading" && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/70">
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-brand-accent border-t-transparent" />
            </div>
          )}

          {item.status === "error" && (
            <div
              title={item.error}
              className="absolute inset-0 flex items-center justify-center bg-rose-50/90 px-1 text-center text-[10px] font-semibold text-rose-700"
            >
              {item.error || "Upload failed"}
            </div>
          )}

          <button
            type="button"
            onClick={() => onRemove(item.localId)}
            aria-label={`Remove ${item.fileName}`}
            className="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-gray-900/70 text-xs font-bold text-white transition hover:bg-rose-600"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
